import React from 'react'
import SuccessSvg from 'modules/react/signup/SuccessSvg'

export default function SignupCompleted () {
  return (
    <div>
      <div className="title title--h3">Tak for din tilmelding!</div>
      <div className="wysiwyg">Du vil blive kontaktet når det er muligt at tilmelde sig kurset</div>
      <div className="image-wrap image-wrap--center">
        {SuccessSvg()}
      </div>
    </div>
  )
}